export default "__VITE_ASSET__lP$8rDAY__"